import React from 'react';

export default () => <div className="loader-animation">Loading...</div>;